import api from "./api";

export async function getPaymentRequest(id) {
  try {
    const response = await api.get(`api/paymentrequests/${id}`);

    return response.data;
  } catch (error) {
    console.error("Error getting payment request", error);
    return null;
  }
}
